import { Subscription } from 'rxjs';
import { BaseService } from './../../../core/services/base.service';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-sales-order-customer-dialog',
  templateUrl: './sales-order-customer-dialog.component.html',
  styleUrls: ['./sales-order-customer-dialog.component.scss']
})
export class SalesOrderCustomerDialogComponent implements OnInit, OnDestroy {
  // subscription1: Subscription;
  // subscription2: Subscription;
  // subscription3: Subscription;

  form: FormGroup;
  titles: any[] = [];
  dialogTitle = 'Create New Customer'
  constructor(
    public dialogRef: MatDialogRef<SalesOrderCustomerDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private baseService: BaseService,
    private dialog: MatDialog
  ) {
    this.form = fb.group({
      salesOrderHeaderId: [null, Validators.compose([])],
      customerCode: [null, Validators.compose([])],
      customerIndicator: [null, Validators.compose([Validators.required])],
      customerName: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      companyTaxNumber: [null, Validators.compose([Validators.maxLength(15)])],
      title: [null, Validators.compose([Validators.required])],
      firstName: [null, Validators.compose([Validators.required, Validators.maxLength(30)])],
      surname: [null, Validators.compose([Validators.required, Validators.maxLength(30)])],
      contact: [null, Validators.compose([Validators.maxLength(50)])],
      contactPlus: [null, Validators.compose([Validators.maxLength(50)])],

      email: [null, Validators.compose([Validators.required, Validators.email, Validators.maxLength(255)])],
      saId: [null, Validators.compose([Validators.minLength(13), Validators.maxLength(13)])],
      telephone: [null, Validators.compose([Validators.required, Validators.maxLength(20)])],
      addTelephone: [null, Validators.compose([Validators.maxLength(20)])],
      contractNr: [null, Validators.compose([Validators.maxLength(20)])],
      vip: [null, Validators.compose([Validators.maxLength(8)])],

      shipToAddr1: [null, Validators.compose([Validators.maxLength(40)])],
      shipToAddr2: [null, Validators.compose([Validators.maxLength(40)])],
      shipToAddr3: [null, Validators.compose([Validators.maxLength(40)])],
      shipToAddr4: [null, Validators.compose([Validators.maxLength(40)])],
      shipToAddr5: [null, Validators.compose([Validators.maxLength(40)])],
      shipPostalCode: [null, Validators.compose([Validators.maxLength(10)])],
      shipToGpsLat: [null, Validators.compose([Validators.min(-90), Validators.max(90)])],
      shipToGpsLong: [null, Validators.compose([Validators.min(-180), Validators.max(180)])],

      soldToAddr1: [null, Validators.compose([Validators.maxLength(40)])],
      soldToAddr2: [null, Validators.compose([Validators.maxLength(40)])],
      soldToAddr3: [null, Validators.compose([Validators.maxLength(40)])],
      soldToAddr4: [null, Validators.compose([Validators.maxLength(40)])],
      soldToAddr5: [null, Validators.compose([Validators.maxLength(40)])],
      soldPostalCode: [null, Validators.compose([Validators.maxLength(10)])],
      soldToGpsLat: [null, Validators.compose([Validators.min(-90), Validators.max(90)])],
      soldToGpsLong: [null, Validators.compose([Validators.min(-180), Validators.max(180)])],

      noEmail: [true],
      noDirectEmail: [true],
      noTelephone: [true],
      noSms: [true],
    });
  }

  ngOnInit() {
    const body = {
      salesOrderHeaderId: this.data.salesOrderHeaderId ? this.data.salesOrderHeaderId : null,
      customerCode: this.data.customerCode ? this.data.customerCode : null
    };

    this.baseService.executeCommand<any>('portal_sales_order_customer_dialog_config', body)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.titles = response.data?.titles || [];
          this.dialogTitle = response.data?.dialogTitle || 'Customer Dialog';

          if (response.data.customer) {
            this.form.patchValue(response.data.customer);
            this.customerIndicatorChanged(this.form.value.customerIndicator, false);
            // this.subscription1 = this.form.controls['title'].valueChanges.subscribe(s => this.setCustomerName());
            // this.subscription2 = this.form.controls['firstName'].valueChanges.subscribe(s => this.setCustomerName());
            // this.subscription3 = this.form.controls['surname'].valueChanges.subscribe(s => this.setCustomerName());
          }
        }
      });

  }

  ngOnDestroy() {
    // if (this.subscription1) this.subscription1.unsubscribe();
    // if (this.subscription2) this.subscription2.unsubscribe();
    // if (this.subscription3) this.subscription3.unsubscribe();
  }

  save() {
    const dialogData: OiGroupDialogData = {
      title: 'Save Customer Details in SYSPRO',
      function: 'portal_oi_group_customer_modify',
      postBody: this.form.getRawValue()
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      if (oiResult.responseCode === 0) {
        this.dialogRef.close(oiResult);
      }
    });
  }

  copyAddress(from: string, to: string) {
    this.form.controls[`${to}ToAddr1`].setValue(this.form.controls[`${from}ToAddr1`].value);
    this.form.controls[`${to}ToAddr2`].setValue(this.form.controls[`${from}ToAddr2`].value);
    this.form.controls[`${to}ToAddr3`].setValue(this.form.controls[`${from}ToAddr3`].value);
    this.form.controls[`${to}ToAddr4`].setValue(this.form.controls[`${from}ToAddr4`].value);
    this.form.controls[`${to}ToAddr5`].setValue(this.form.controls[`${from}ToAddr5`].value);
    this.form.controls[`${to}PostalCode`].setValue(this.form.controls[`${from}PostalCode`].value);
    this.form.controls[`${to}ToGpsLat`].setValue(this.form.controls[`${from}ToGpsLat`].value);
    this.form.controls[`${to}ToGpsLong`].setValue(this.form.controls[`${from}ToGpsLong`].value);
  }

  customerIndicatorChanged(customerIndicator: string, overwriteCustomerName: boolean) {
    if (customerIndicator === 'Customer') {
      this.form.controls['customerName'].disable();
      this.form.controls['customerName'].clearValidators();
      if (overwriteCustomerName) {
        this.setCustomerName();
      }
    } else {
      this.form.controls['customerName'].enable();
      this.form.controls['customerName'].setValidators(Validators.compose([Validators.required, Validators.maxLength(50)]));
    }
  }

  setCustomerName() {
    if (this.form.value.customerIndicator) {
      let title = this.form.value.title || '';
      let firstName = this.form.value.firstName || '';
      let surname = this.form.value.surname || '';

      this.form.controls['customerName'].setValue(`${title} ${firstName} ${surname}`);
    }
  }
}
